import React from "react";
import { XExecutableTester } from "../XExecutableTester";
import { RuleTableConfiguration } from "../../../rule-engine-core/Rule/Table/Rule/RuleTableConfiguration";
import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { RuleTableColumn } from "../../../rule-engine-core/Rule/Table/Rule/Structure/RuleTableRuleColumn";
import { ExpressionConfiguration } from "../../../rule-engine-core/Expressions/ExpressionConfiguration";
import { LessThanExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/LessThanExpression";
import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { NotExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/NotExpression";
import { getIfElseSimpleRule } from "../../../Expressions/Testing/LogicData";
import { StoryNode } from "../../StoryBook/StoryData";

const getRuleTableWithData = () => {
    const ruleDefinition = new RuleTableConfiguration();

    let idatadef = new DataDefinition();
    idatadef.fields.push(new NumberDataDefinition("income"));
    idatadef.fields.push(new BooleanDataDefinition("isMarried"));
    ruleDefinition.inputData = idatadef;

    for (let fidx in idatadef.fields) {
        let f = idatadef.fields[fidx];
        let ruleColumn: RuleTableColumn | undefined;
        if (fidx !== "0") {
            ruleColumn = ruleDefinition.addRuleColumn(f.name);
        } else {
            ruleColumn = ruleDefinition.ruleColumns[0];
        }

        ruleColumn.path = f.name;
        ruleColumn.name = f.name;
    }

    let odatadef = new DataDefinition();

    odatadef.fields.push(new StringDataDefinition("name"));

    ruleDefinition.executionResult = () => odatadef;

    ruleDefinition.addRow();

    let _exp = new ExpressionConfiguration();

    let lessThan = new LessThanExpression();
    lessThan.value1.variableName = "income";
    lessThan.value2.value = 5000;

    ruleDefinition.rows[0].cells[0].expression = new ExpressionConfiguration();
    ruleDefinition.rows[0].cells[0].expression.expression = lessThan;

    ruleDefinition.rows[0].cells[1].expression = new ExpressionConfiguration();
    ruleDefinition.rows[0].cells[1].expression.variableName = "isMarried";

    ruleDefinition.rows[0].resultCells[0].value = "Jose Chacin";

    lessThan = new LessThanExpression();
    lessThan.value2.variableName = "income";
    lessThan.value1.value = 5000;

    ruleDefinition.rows[1].cells[0].expression = new ExpressionConfiguration();
    ruleDefinition.rows[1].cells[0].expression.expression = lessThan;

    ruleDefinition.rows[1].cells[1].expression = new ExpressionConfiguration();

    let notExpression = new NotExpression();
    notExpression.value1.variableName = "isMarried";

    ruleDefinition.rows[1].cells[1].expression.expression = notExpression;
    ruleDefinition.rows[1].resultCells[0].value = "Bruno Pereira";

    ruleDefinition.defaultResult[ruleDefinition.resultColumns[0]._id].value = "James";

    return ruleDefinition;
};

export const RuleTableTester = [
    new StoryNode(
        () => {
            let ruleDefinition = getRuleTableWithData();
            return <XExecutableTester executable={ruleDefinition} />;
        },
        "Shared",
        "Tester",
        "Rule Table",
        "Default",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getRuleTableWithData();

            ruleDefinition.allowDefaultResults = false;

            return <XExecutableTester executable={ruleDefinition} />;
        },
        "Shared",
        "Tester",
        "Rule Table",
        "No Default",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getRuleTableWithData();
            let idatadef = new DataDefinition();
            idatadef.fields.push(new NumberDataDefinition("income"));
            idatadef.fields.push(new BooleanDataDefinition("isMarried"));
            idatadef.fields.push(new BooleanDataDefinition("isEmployee"));
            idatadef.fields.push(new BooleanDataDefinition("isContractor"));
            ruleDefinition.inputData = idatadef;

            ruleDefinition.rows[0].cells[1].expression!.expression = getIfElseSimpleRule().expression;
            ruleDefinition.setRuleColumn(ruleDefinition.ruleColumns[1], "isContractor");

            return <XExecutableTester executable={ruleDefinition} />;
        },
        "Shared",
        "Tester",
        "Rule Table",
        "If Then",
    ),
];
